import React, { useContext, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import { useSettings } from '../mall_settings/SettingsProvider';

import { mapiHeaders } from './utils';
import { serializePromoRequest } from './mapiOrderSerializers';
import numberOrZero from '../utils/numberOrZero';

export const PromoContext = React.createContext();
export const noResponseError = 'NO_RESPONSE';

export const lookupPromotionalCostByLineItem = (promotions, lineItemId) => {
    const { egiftCards = [], shippingGroups = [] } = promotions;
        let lineItemPromo = egiftCards.find(egc => egc.lineItem === lineItemId);
        if (!lineItemPromo) {
            
            
            for (let i = 0; i < shippingGroups.length; i++) {
                const shippingGroup = shippingGroups[i];
                const { certs = [] } = shippingGroup;
                lineItemPromo = certs.find(cert => cert.lineItem === lineItemId);
                if (lineItemPromo) {
                    break;
                }
            }
        }

        if (lineItemPromo) {
            const discountRewardAmount = Number(lineItemPromo.lineItemDiscountRewardAmount) || 0.00;
            const lineItemPromoCost = (Number(lineItemPromo.faceValue) * Number(lineItemPromo.quantity)) - discountRewardAmount;
            const perCardDiscountRewardAmount = Number(lineItemPromo.faceValue) - Number(lineItemPromo.certCost);
            return {lineItemPromoCost, discountRewardAmount, perCardDiscountRewardAmount};
        }
        return null;
};

export const ApplyPromosProvider = ({ children }) => {
    const { mapiUrl, orderingToken } = useSettings();

    const [promoError, setPromoError] = useState(undefined);
    const [promoLoading, setPromoLoading] = useState(false);
    const [promoDiscounts, setPromoDiscounts] = useState({});

    const postApplyPromo = async (applyPromoData) => {
        setPromoLoading(true);
        setPromoError(undefined);
        const applyPromoUrl = `${mapiUrl || ''}/capi/mall/promo/apply/`;
        const config = {
            headers: mapiHeaders(orderingToken),
        };

        try {
            const { data } = await axios.post(applyPromoUrl, applyPromoData, config);
            const { totalDiscountRewardAmount, egiftCards = [], shippingGroups = [] } = data;
            data.totalDiscountRewardAmount = numberOrZero(totalDiscountRewardAmount);
            data.egiftCards = egiftCards.map(egc => {
                const { faceValue, certCost } = egc;
                return {
                    ...egc,
                    faceValue: numberOrZero(faceValue),
                    certCost: numberOrZero(certCost),
                };
            });
            data.shippingGroups = shippingGroups.map(group => {
                const { certs } = group;
                return {
                    ...group,
                    certs: certs.map(cert => {
                        const { faceValue, certCost } = cert;
                        return {
                            ...cert,
                            faceValue: numberOrZero(faceValue),
                            certCost: numberOrZero(certCost),
                        };
                    }),
                };
            });

            setPromoDiscounts(data);
        } catch (error) {
            if (error.response) {
                setPromoError(error.response);
            } else if (error.request) {
                
                setPromoError(noResponseError);
            } else {
                
                setPromoError(error.toString());
            }
        }
        setPromoLoading(false);
    };

    const applyPromos = async (lineItems, amount) => {
        const lineItemPromos = lineItems.map((val) => val.product && val.product.promo).filter((val) => val);
        const lineItemsHavePromos = lineItemPromos.length > 0;
        if (!lineItemsHavePromos || promoLoading) {
            setPromoDiscounts({});
            return;
        }
        try {
            postApplyPromo(serializePromoRequest(lineItems, amount)).then();
        } catch (error) {
            setPromoError(error.toString());
        }
    };

    const getPromotionalCostForLineItem = lineItemId => {
        return lookupPromotionalCostByLineItem(promoDiscounts, lineItemId);
    };

    return (
        <PromoContext.Provider
            value={{
                applyPromos,
                getPromotionalCostForLineItem,
                promoError,
                promoLoading,
                promoDiscounts,
            }}
        >
            {children}
        </PromoContext.Provider>
    );
};

ApplyPromosProvider.propTypes = {
    children: PropTypes.object.isRequired,
};

export const useApplyPromos = () => useContext(PromoContext);
